// Info/board/DiscoverSwipe.js
import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { withTranslation } from "react-i18next";

import bank10 from "assets/images/info/bank10.png";
import SwipeCardDeck from "./SwipeCardDeck";
import PersonMetaInfo from "./PersonMetaInfo";

const samplePeople = [
  { name: "Alice", age: 25, desc: "喜歡咖啡與登山", img: "/images/avatars/avatar-1.jpg" },
  { name: "Bob", age: 30, desc: "書蟲兼健身狂", img: "/images/avatars/avatar-8.jpg" },
  { name: "Carol", age: 27, desc: "藝術創作者", img: "/images/avatars/avatar-5.jpg" },
];

const DiscoverSwipe = ({ t }) => {
  document.title = "點數銀行主頁 | TheChart.AI";

  const [currentIndex, setCurrentIndex] = useState(samplePeople.length - 1);
  const [likedPeople, setLikedPeople] = useState([]);
  const [dislikedPeople, setDislikedPeople] = useState([]);


  /*--------------------------*/
  /* Screen Detection
  /*--------------------------*/
  const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [isLargeScreen, setIsLargeScreen] = useState(!isMobileDevice || window.innerWidth >= 567);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      setIsLargeScreen(!isMobile || window.innerWidth >= 567);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(()=>{
    console.log('currentIndex:', currentIndex);
  },[currentIndex])


  const [swipeHistory, setSwipeHistory] = useState([]);

  const handleSwipeDecision = (direction, person) => {
    if (direction === "right") {
      setLikedPeople(prev => [...prev, person]);
    } else if (direction === "left") {
      setDislikedPeople(prev => [...prev, person]);
    }

    setSwipeHistory(prev => [...prev, { direction, person }]);
  };

  const handleUndoSwipe = () => {
    if (swipeHistory.length === 0) return;

    const last = swipeHistory[swipeHistory.length - 1];
    const updatedHistory = swipeHistory.slice(0, -1);

    if (last.direction === "right") {
      setLikedPeople(prev => prev.filter(p => p.name !== last.person.name));
    } else if (last.direction === "left") {
      setDislikedPeople(prev => prev.filter(p => p.name !== last.person.name));
    }

    setSwipeHistory(updatedHistory);
  };

  return (
    <div className="bank-main-page page-content d-flex flex-column" 
      style={{
        height: "100vh",
        //backgroundImage: `url(${bank10})`,
        backgroundSize: "cover",
      }}
    >
      {/* Swipe area */}
      <div 
        style={{ 
          flex: isLargeScreen ? "8" : "6",
          position: "relative", 
          height: "100%" 
        }}
      >
        <SwipeCardDeck
          people={samplePeople}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          onSwipeDecision={handleSwipeDecision}
          onUndoSwipe={handleUndoSwipe}
          isLargeScreen={isLargeScreen}
        />
      </div>

      {/* Meta info area */}
      <div style={{
        flex: isLargeScreen ? "2" : "4",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        padding: "1rem",
        overflowY: "auto"
      }}>
        {currentIndex >= 0 ? (
          <PersonMetaInfo person={samplePeople[currentIndex]} />
        ) : (
          <p>🎉 沒有更多推薦啦～</p>
        )}

        <div>
          <strong>👍 Liked:</strong> {likedPeople.map(p => p.name).join(", ")}
        </div>
        <div>
          <strong>👎 Disliked:</strong> {dislikedPeople.map(p => p.name).join(", ")}
        </div>

      </div>
    </div>
  );
};

export default withTranslation()(DiscoverSwipe);




